import { Plate } from '@udecode/plate';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import useAutofocus from './hooks/use_autofocus';

export default function TextEditor(props) {
  const {
    autoFocus,
    children,
    className,
    editorRef,
    editorId,
    minHeight,
    onChange,
    placeholder,
    readOnly,
    width,
  } = props;
  const editor = editorRef.current;

  const editableProps = {
    autoFocus,
    placeholder: placeholder || 'Type...',
    readOnly,
  };

  useAutofocus(editor, autoFocus);

  return (
    <React.Fragment>
      <Plate
        editableProps={editableProps}
        editor={editor}
        id={editorId}
        onChange={onChange}
        plugins={editor.plugins}
        renderEditable={content => (
          <StyleWrapper $minHeight={minHeight} $width={width} className={className} data-aid={props['data-aid']}>
            {content}
          </StyleWrapper>
        )}
      >
        {children}
      </Plate>
    </React.Fragment>
  );
}

TextEditor.defaultProps = {
  autoFocus: true,
  minHeight: '23vh',
  plugins: [],
};

TextEditor.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  'data-aid': PropTypes.string,
  editorId: PropTypes.string,
  editorRef: PropTypes.shape({
    current: PropTypes.any,
  }),
  minHeight: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  width: PropTypes.string,
};

const StyleWrapper = styled.span`
  ${p => (p.$width ? `width: ${p.$width};` : '')}
  [data-slate-editor='true'] {
    min-height: ${p => p.$minHeight} !important;
    outline: none;
    padding: 4px 8px;
  }
`;

/**
 * Returns a cached copy of the return value of `pluginFunc`. We cache this so that Slate does not
 * yell at us about changing the `plugins` prop too frequently (as that is inefficient).
 */
export function usePlugins(pluginFunc, inputs = []) {
  return useMemo(pluginFunc, inputs);
}
